export function onlyUnique(value: any, index: any, array: any[]) {
    return array.indexOf(value) === index;
}
